<template>
    <div>
        <div class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Service"
                @click="showAddItem">
                <span class="fal fa-plus mr-2"></span>
                <span>{{ $t('button_link.add') }}{{ $t('subMenu.salon_menu_service') }}</span>
            </button>
        </div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                        :placeholder="$t('label.search')" v-model="searchItem" @keypress.enter="filterSearch">
                                    <button
                                        class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                                        @click="filterSearch">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect
                                            :value="selectedSubcategory"
                                            :options="subCategoryFilter"
                                            track-by="folderID"
                                            label="name"
                                            :show-labels="false"
                                            openDirection="below"
                                            @select="filterBySubCategory">
                                            <span slot="noResult">
                                                {{ $t('table.no_records') }}
                                            </span>
                                            <template slot="option" slot-scope="{ option }">
                                                {{  option.name }}
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-control custom-checkbox mb-2">
                        <input type="checkbox" class="custom-control-input" id="showDisabled" @change="filterEnable($event)" v-model="showDisabled">
                        <label class="custom-control-label" for="showDisabled">Show Disabled Only</label>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{ $t('button_link.clear_filter') }}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in categoryFilter" :key="c.sectionID">
                                <a :class="{ 'active': selectedCategory == c.sectionID }" class="nav-link" role="tab" @click="filterByCategory(c.sectionID)">{{ c.name }}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{ $t('table.no_records') }}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, })
                                    }}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                        @input="handlePagination" aria-controls="tblItemItems"></b-pagination>
                                </div>
                            </div>
                            <div v-if="!isSpinnerShow && totalEntries != 0" class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="itemItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(img)="data">
                                            <span v-if="data.item.image.image == ''">-</span>
                                            <img v-else class="img-thumbnail" :src="data.item.image.image" />
                                        </template>
                                        <template #cell(title)="data">
                                            <a class="text-primary fw-500 link" @click="showEditItem(data.item)">{{ data.item.name }}</a>
                                        </template>
                                        <template #cell(price)="data">
                                            {{ formatPrice(data.item.price.price) }}
                                        </template>
                                        <template #cell(basePrice)="data">
                                            {{ formatPrice(data.item.price.base) }}
                                        </template>
                                        <template #cell(category)="data">
                                            {{ getCategoryText(data.item) }}
                                        </template>
                                        <template #cell(subCategory)="data">
                                            {{ getSubCategoryText(data.item) }}
                                        </template>
                                        <template #cell(duration)="data">
                                            {{ data.item.duration.duration == 0 ? '-' : formatTime(data.item.duration.duration) }}
                                        </template>
                                        <template #cell(isEnable)="data">
                                            <span class="badge"
                                                :class="data.item.status.enable == 1 ? 'badge-primary' : 'badge-secondary'">
                                                {{ data.item.status.enable == 1 ?  $t('table.value.enable') : $t('table.value.disable') }}
                                            </span>
                                        </template>
                                        <template #cell(isOnline)="data">
                                            <span :class="{ 'badge badge-warning': data.item.status.online == '1' }">
                                                {{ data.item.status.online == '1' ? $t('label.online') : '-' }}
                                            </span>
                                        </template>
                                        <template #cell(gallery)="data">
                                            <a class="link text-primary" :title="$t('button_link.view_update', { 'item': $t('table.header.gallery') })"
                                                @click="editGallery(data.item)">
                                                <i class="fal fa-images fs-xl"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <itemForm
            ref="dataModal"
            :isEdit="true"
            :category="categoryCache"
            :subcategory="subCategoryCache"
            :itemItemsCache="itemItemsCache"
            @onItemAddOrEdit="onItemAddOrEdit"
            @onItemChange="onItemChange">
        </itemForm>
        <itemGallery ref="itemGallery"></itemGallery>
    </div>
</template>

<script>
import moment from 'moment'
import ItemGallery from './Gallery'
import ItemForm from './Form'
import { formatTime, formatPrice, formFormatTime } from './../../../../assets/js/dashboard/utilities'
import { setReturnData, handleSessionExpired, setCategoryLabel, getSubcategory, getCategoryText }
    from './../../../../assets/js/dashboard/dashboard'


export default {
    name: 'itemList',
    components: {
        ItemForm, ItemGallery
    },
    data() {
        let fromPackage = localStorage.fromPackage != "true" ? false : true;
        return {
            typeID: 1,
            isSpinnerShow: true,

            categoryCache: [],
            categoryMap: {},
            sectionMap: {},
            categoryFilter: [],

            subCategoryCache: [],
            subCategoryMap: {},
            folderMap: {},
            subCategoryFilter: [],

            searchItem: "",
            showDisabled: false,
            selectedCategory: "all",
            selectedSubcategory: {},

            itemItems: [],
            itemItemsCache: {},
            selectedItem: {},

            editToggleModal: false,
            deleteToggleModal: false,

            page: 0,
            totalEntries: 0,
            totalPage: 0,
            startPage: 1,
            endPage: 0,
            perPage: 100,
            currentPage: 1,

            exportHeaders: [],
            exportData: [],
            exportFileName: "",
            itemExportData: [],
        }
    },
    computed: {
        fields() {
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "img", label: this.$i18n.t('table.header.image'), thClass: 'thead-themed align-middle', tdClass: 'width-12' },
                { key: "skuID", label: this.$i18n.t('table.header.id', { 'item': this.$i18n.t('subMenu.salon_menu_service') }), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true },
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true },
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true },
                { key: "basePrice", label: this.$i18n.t('table.header.base_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true },
                { key: "category", label: 'Section', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "subCategory", label: 'Folder', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "duration", label: this.$i18n.t('table.header.duration'), thClass: 'thead-themed align-middle', sortable: true, tdClass: 'align-middle' },
                { key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center' },
                { key: "isOnline", label: this.$i18n.t('table.header.online'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center' },
                { key: "gallery", label: this.$i18n.t('table.header.gallery'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center' },
                { key: "action", label: "", thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center' },
            ]
        },
        exportFields() {
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.id', { 'item': this.$i18n.t('subMenu.salon_menu_service') })).toUpperCase()] = "skuID"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.price')).toUpperCase()] = "price"
            ret[(this.$i18n.t('table.header.base_price')).toUpperCase()] = "basePrice"
            ret['Section'.toUpperCase()] = "category"
            ret['Folder'.toUpperCase()] = "subCategory"
            ret[(this.$i18n.t('table.header.duration')).toUpperCase()] = "duration"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
            ret[(this.$i18n.t('table.header.online')).toUpperCase()] = "isOnline"
            return ret
        },
    },
    // watch: {
    //     "$i18n.locale"(val) {
    //         this.setOptions()

    //         var b = Object.assign({}, this.selectedSubcategory)
    //         this.selectedSubcategory = this.subCategories.find(obj => obj.id == b.id)

    //         this.setExportData(this.itemExportData)
    //     }
    // },
    methods: {
        setOptions() {
            var category = JSON.parse(this.$store.state.category);
            this.categoryFilter = setCategoryLabel(this, true, this.$i18n.t('label.all', { 'item': this.$i18n.t('label.category') }), category.service)
            this.subCategoryFilter = setCategoryLabel(this, false, this.$i18n.t('label.all', { 'item': this.$i18n.t('label.subcategory') }), this.subCategories)
        },
        async loadSection() {
            const url = "https://menu.tunai.io/business/sections?typeID=" + this.typeID

            await this.$axios.get(url, { headers: { token: this.$util.getSessionToken() } })
                .then((response) => {
                    var results = this.categoryCache = response.data.sections;

                    for(let item of results) {
                        if(item['categoryID'] !== -1) {
                            this.categoryMap[item['categoryID']] = item
                        }

                        this.sectionMap[item['sectionID']] = item
                    }

                    this.categoryFilter = [{sectionID: "all", name: 'All'}].concat(this.categoryCache)
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == "Invalid Token") {
                        handleSessionExpired();
                    }
                })
        },
        async loadFolder() {
            const url = "https://menu.tunai.io/business/folder?typeID=" + this.typeID
            // const url = "https://m5.tunai.io/business/setting/menu/folder?type=service"

            await this.$axios.get(url, { headers: { token: this.$util.getSessionToken() } })
                .then((response) => {
                    var results = this.subCategoryCache = response.data.folders;

                    for(let item of results) {
                        if(item['subcategoryID'] !== -1) {
                            this.subCategoryMap[item['subcategoryID']] = item
                        }

                        this.folderMap[item['folderID']] = item
                    }
                    
                    this.subCategoryFilter = [{folderID: "all", name: 'All Folders'}].concat(this.subCategoryCache)
                    this.selectedSubcategory = this.subCategoryFilter[0]
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == "Invalid Token") {
                        handleSessionExpired();
                    }
                })
        },

        getImage(img) {
            return img
        },
        formatPrice(price) {
            return formatPrice(price);
        },
        formatTime(num) {
            return formatTime(num);
        },
        getCategoryText(item) {
            if(item.section) {
                if(item.section.name) {
                    return item.section.name
                }
                if(item.section.sectionID) {
                    let temp = this.sectionMap[item.section.sectionID]
                    if(temp && temp.name) {
                        return temp.name
                    }
                }
            }

            if(item.misc && item.misc.categoryID !== undefined && item.misc.categoryID !== null && item.misc.categoryID !== '') {
                let temp = this.categoryMap[item.misc.categoryID]
                if(temp && temp.name) {
                    return temp.name
                }

                return 'Category ' + item.misc.categoryID
            }

            return '-'
        },
        getSubCategoryText(item) {
            if(item.folder) {
                if(item.folder.name) {
                    return item.folder.name
                }
                if(item.folder.folderID) {
                    let temp = this.folderMap[item.folder.folderID]
                    if(temp && temp.name) {
                        return temp.name
                    }
                }
            }

            if(item.misc && item.misc.subcategoryID) {
                let temp = this.subCategoryMap[item.misc.subcategoryID]
                if(temp && temp.title) {
                    return temp.title
                }
            }

            return '-'
        },

        clearFilter() {
            this.isEnable = true;
            this.searchItem = "";
            this.filterByCategory("all");
        },
        filterSearch() {
            this.loadData()
        },
        async filterByCategory(item) {
            this.page = 0;
            this.selectedCategory = item;

            let selectedCategory = this.sectionMap[item] || {}

            let temp = []
            let subcategoryInSelection = false
            for(let item of this.subCategoryCache) {
                if(this.selectedCategory === 'all' || String(item['section']['sectionID']) === String(selectedCategory['sectionID'])) {
                    if(String(this.selectedSubcategory['folderID']) === String(item['folderID'])) {
                        subcategoryInSelection = true
                    }
                    temp.push(item)
                }
            }

            this.subCategoryFilter = [{folderID: "all", name: 'All Folders'}].concat(temp)
 
            if(!subcategoryInSelection) {
                this.selectedSubcategory = this.subCategoryFilter[0]
            }

            this.loadData()
        },
        filterBySubCategory(item) {
            this.selectedSubcategory = item;
            this.loadData()
        },
        filterEnable(e) {
            this.isEnable = e.target.checked ? true : false;
            this.loadData()
        },
        async loadData() {
            this.itemItemsCache = {}

            let $vm = this;
            let QUERY_STRING = "?typeID=" + this.typeID
            if(this.searchItem) {
                QUERY_STRING += '&search=' + this.searchItem
            }
            if(this.selectedCategory !== 'all') {
                let selectedCategory = this.sectionMap[this.selectedCategory] || {}
                if(selectedCategory['categoryID'] >= 0) {
                    // QUERY_STRING += '&categoryID=' + selectedCategory['categoryID']
                }
                QUERY_STRING += '&sectionID=' + selectedCategory['sectionID']
            }
            if(this.selectedSubcategory && this.selectedSubcategory.folderID && this.selectedSubcategory.folderID !== 'all') {
                QUERY_STRING += '&folderID=' + this.selectedSubcategory.folderID
            }
            // if(this.selectedSubcategory && this.selectedSubcategory.subcategoryID && this.selectedSubcategory.subcategoryID !== 'all') {
            //     QUERY_STRING += '&subcategoryID=' + this.selectedSubcategory.subcategoryID
            // }
            if(this.showDisabled) {
                QUERY_STRING += '&enable=0'
            } else {
                QUERY_STRING += '&enable=1'
            }
            let url = 'https://menu.tunai.io/business/sku' + QUERY_STRING;
            url += "&page=" + this.page

            this.isSpinnerShow = true
            await $vm.$axios({
                method: 'get',
                url: url,
                // baseURL: this.$axios.defaults.baseURL, 
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    let temp = response.data.skus
                    response.data.items = temp
                    response.data.count = temp.length

                    for(let item of temp) {
                        this.itemItemsCache[item['name']] = item['skuID']
                    }

                    var retData = setReturnData(response.data.items, response.data.total, $vm.page)
                    $vm.itemItems = retData.result;
                    $vm.totalEntries = retData.count;
                    $vm.totalPage = retData.totalPage;

                    $vm.startPage = retData.startPage;
                    $vm.endPage = retData.endPage;
                    $vm.isSpinnerShow = false;

                    if(temp.length === response.data.total) {
                        this.setExportData(temp)
                    } else {
                        this.getExportData(QUERY_STRING)
                    }
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if (error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        handlePagination(pg) {
            if (pg != null) {
                this.page = pg - 1
                this.loadData()
            }
        },

        async getExportData(strFilter) {
            let $vm = this;
            let QUERY_STRING = strFilter
            // const url =  this.$api.MENU_ITEM + QUERY_STRING;
            const url = 'https://menu.tunai.io/business/sku' + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    result = response.data.skus

                    // let temp = []
                    // for (let service of response.data.skus) {
                    //     if (service['typeID'] === this.typeID) {
                    //         temp.push(service)
                    //     }
                    // }
                    // result = temp
                })
                .catch((err) => {
                    console.log(err)
                    var error = err.response.data.error;
                    if (error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
            this.itemExportData = result
            this.setExportData(result)
        },
        setExportData(data) {
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_menu_service`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), " "];
            this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            for (var i = 0; i < data.length; i++) {
                this.itemItemsCache[data[i]['name']] = data[i].skuID

                this.exportData.push({
                    index: i + 1,
                    skuID: data[i].skuID,
                    title: data[i].name,
                    price: data[i].price.price,
                    basePrice: data[i].price.base,
                    category: this.getCategoryText(data[i]),
                    subCategory: this.getSubCategoryText(data[i]),
                    duration: data[i].duration.duration,
                    isEnable: data[i].status.enable ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable'),
                    isOnline: data[i].status.online ? this.$i18n.t('label.online') : '-'
                })
            }
        },

        showAddItem() {
            let selectedCategory = this.selectedCategory
            let selectedSubcategory = this.selectedSubcategory.folderID

            if (selectedCategory === 'all') {
                let cache = this.folderMap[this.selectedSubcategory.folderID]
                if (cache) {
                    selectedCategory = cache['section']['sectionID']
                }
            }

            this.$refs.dataModal.showAddModal(selectedCategory, selectedSubcategory)
        },

        showEditItem(item) {
            this.$refs.dataModal.isSpinnerShow = true
            this.selectedItem = item
            this.editToggleModal = true;
            this.$refs.dataModal.showEditModal(item);
        },
        async onItemChange() {
            await this.loadData("")

            var item = {}
            for (var i = 0; i < this.itemItems.length; i++) {
                if (this.itemItems[i].skuID == this.selectedItem.skuID) {
                    item = this.itemItems[i]
                    break
                }
            }
            this.$refs.dataModal.showEditModal(item);
        },
        onItemAddOrEdit() {
            this.loadData()
        },
        
        editGallery(item) {
            this.$refs.itemGallery.editItemGallery(item.skuID, item.name)
        },
    },
    async mounted() {
        let $vm = this;

        // $vm.subCategories = await getSubcategory($vm, "", "");
        // for(let subcategory of $vm.subCategories) {
        //     this.subcategoryCache[subcategory.id] = subcategory['text']
        // }
        // $vm.setOptions()
        // $vm.selectedSubcategory = $vm.subCategoryFilter[0]
        
        await this.loadSection()
        await this.loadFolder()

        this.loadData()
    }
}
</script>
<style scoped>
.show {
    display: block;
}
</style>
<style>
.nav-link,
.link {
    cursor: pointer;
}

.link>i {
    font-size: large;
}

.modal-body {
    max-height: 65vh;
    overflow-y: auto;
}

.modal-lg {
    max-width: 1000px;
}

.width-12 {
    width: 12%;
}
</style>